import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface HomeCard {
  id: string;
  key: string;
  label: string;
  description: string | null;
  icon_name: string;
  image_url: string | null;
  route: string | null;
  permission_key: string | null;
  alt_permissions: string[] | null;
  is_coming_soon: boolean;
  is_active: boolean;
  sort_order: number;
}

// Hardcoded fallback — ensures Home page never blank
const FALLBACK_CARDS: HomeCard[] = [
  { id: '1', key: 'site', label: 'Công trường', description: 'Quản lý công trường, chấm công, ảnh', icon_name: 'HardHat', image_url: null, route: '/site', permission_key: 'SITE_ACCESS', alt_permissions: null, is_coming_soon: false, is_active: true, sort_order: 1 },
  { id: '2', key: 'forms', label: 'Đơn từ', description: 'Tạo và theo dõi đơn từ', icon_name: 'FileText', image_url: null, route: '/forms', permission_key: 'SITE_ACCESS', alt_permissions: null, is_coming_soon: false, is_active: true, sort_order: 2 },
  { id: '3', key: 'projects', label: 'Dự án', description: 'Quản lý dự án', icon_name: 'Briefcase', image_url: null, route: '/projects', permission_key: 'PROJECTS_ACCESS', alt_permissions: null, is_coming_soon: false, is_active: true, sort_order: 3 },
  { id: '4', key: 'library', label: 'Thư viện', description: 'Specs & tài liệu', icon_name: 'BookOpen', image_url: null, route: '/library', permission_key: 'canAccessSpecs', alt_permissions: ['SPECS_ACCESS'], is_coming_soon: false, is_active: true, sort_order: 4 },
  { id: '5', key: 'people', label: 'Nhân sự', description: 'Quản lý nhân sự & đội nhóm', icon_name: 'Users', image_url: null, route: '/people', permission_key: 'HR_ACCESS', alt_permissions: null, is_coming_soon: false, is_active: true, sort_order: 5 },
  { id: '6', key: 'solid-way', label: 'SOLID Way', description: 'Coming soon', icon_name: 'Star', image_url: null, route: null, permission_key: null, alt_permissions: null, is_coming_soon: true, is_active: true, sort_order: 6 },
];

export const useHomeCards = () => {
  return useQuery({
    queryKey: ['home-cards'],
    queryFn: async (): Promise<HomeCard[]> => {
      const { data, error } = await supabase
        .from('home_cards')
        .select('*')
        .order('sort_order', { ascending: true });

      if (error) throw error;
      if (!data || data.length === 0) return FALLBACK_CARDS;
      return data as HomeCard[];
    },
    staleTime: 10 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
    placeholderData: FALLBACK_CARDS,
  });
};

export { FALLBACK_CARDS };
